import gql from 'graphql-tag'

export default {
  service() {
    return {
      query: gql`
        query Query($serviceId: ID!) {
          service(id: $serviceId) {
            id
            customer_reference
            service_location_id
            biz_mon_id
            subnet_size
            account {
              name
            }
            location {
              id
              premise {
                id
                address
              }
            }
            product {
              id
              service_reference
              product_reference
            }
            plan {
              id
              speed
            }
          }
        }
      `,
      variables() {
        return {
          serviceId: this.$route.params.id
        }
      },
      result({ data }) {
        this.STORE_SERVICE(data.service)
      }
    }
  }
}
